import React from "react";
import Preloader from "../../helper/Preloader";
 import Breadcrumb from "../../components/Breadcrumb";
  import ScrollToTop from "react-scroll-to-top";
import HeaderOneCustomer from "../../componentsAmazon/HeaderOneCustomer";
import ShopSectionDetailsAmazon from "../../componentsAmazon/ShopSectionDetailsAmazon";
import { useDispatch } from "react-redux";
import { setSelectedProductStore } from "../../common/slices/productSlice";
import FooterOne from "../../components/FooterOne";

const ShopPageDetailsAmazon = () => {

  const dispatch = useDispatch(); 
  
  const handleBackToStore = () => {
    dispatch(setSelectedProductStore(null)); // Clear selected product
  };
 
    
  return (
    <>

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderOne */}
      <HeaderOneCustomer category={true} />
 
      {/* Conditionally Render Components */}

         <ShopSectionDetailsAmazon  onBack={handleBackToStore} />
      
      {/* FooterOne */}
      <FooterOne />


    </>
  );
};

export default ShopPageDetailsAmazon;
